<template>
  <div v-if="meState">
    <LayoutDefaultHeader />
    <LayoutDefaultNavDrawer />
    <v-main>
      <slot />
    </v-main>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import LayoutDefaultHeader from './header'
import LayoutDefaultNavDrawer from './naw-drawer'
import meQuery from '@/services/gql/types/Me/queries/me.gql'

export default {
  name: 'LayoutDefault',
  components: {
    LayoutDefaultHeader,
    LayoutDefaultNavDrawer
  },
  computed: {
    ...mapState('app', ['me']),
    meState: {
      get () {
        return this.me
      },
      set (value) {
        this.setAppState({ key: 'me', value })
      }
    }
  },
  methods: {
    ...mapMutations('app', {
      setAppState: 'set'
    }),
    updateMe () {
      return this.$apollo.queries.me.refetch()
    }
  },
  apollo: {
    me: {
      fetchPolicy: 'network-only',
      query: meQuery,
      context: {
        headers: {
          'execution-context': 'own'
        }
      },
      manual: true,
      result ({ data }) {
        this.meState = data.me
      }
    }
  },
  created () {
    this.$eh.$on('update-me', this.updateMe)
  },
  beforeDestroy () {
    this.$eh.$off('update-me', this.updateMe)
  }
}
</script>
